import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  customTool: {
    marginLeft: '13px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    cursor: 'pointer',
    border: '1px solid #ccc',
    borderRadius: '10px',
    padding: '4px'
  },
  disableImportLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  dialogModal: {
    '& .MuiPaper-root': {
      '& .makeStyles-dialogTitle-38': {
        padding: '16px 12px !important',
      },
      maxWidth: '900px',
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  disableIcon: {
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  importLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
  },
  invalidRow: {
    backgroundColor: '#ffcccc !important'
  },
  inputField: {
    width: '100%'
  },
  targetContainer: {
    marginBottom: '20px',
    border: '2px solid grey',
    margin: '12px'
  },
  entryLabel: {
    marginLeft: '13px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '10px'
  },
}));
export default styles;
